import React from 'react'
import { Badge } from '@enamelai/design-system'

type PatientProfileAccountBadgeProps = {
  isDefault: boolean
}

function PatientProfileAccountBadge({
  isDefault,
}: PatientProfileAccountBadgeProps): React.ReactElement | null {
  if (!isDefault) return null

  return <Badge mode="tinted" color="vivid-green" label="Default" />
}

export default PatientProfileAccountBadge
